import React from "react";
import CodeBlock from 'react-copy-code';
import Track from 'utils/tracker';
import alertify from 'alertifyjs';


export const SDK_VERSION = '0.0.16';


function onClickCodeCopy(category, key){
  
  Track.event('code_copied');
  // console.log(category + "_" + key);

  alertify.warning('Code snippet copied', 1.5);  
}

export function TriggerJS (props) {
  const show_xid = props.show_xid || "INSERT_SHOW_ID_HERE";
  const category = "show_trigger";
  return (
    <CodeBlock onCopy={() => onClickCodeCopy(category, show_xid)} >
      <pre className="rounded highlight-info-1">
        <code id="config-copy">
          &#60;button onClick="window.DivShow.Play('{show_xid}')"&#62;Play&#60;/button&#62;
        </code>
      </pre>
    </CodeBlock>
  )
}

export function PlayerJS(props){
  const show_xid = props.show_xid || "INSERT_SHOW_ID_HERE";
  const category = 'player';
  
  return (
    <CodeBlock onCopy={() => onClickCodeCopy(category, show_xid)} >
      <pre className="rounded highlight-info-2">
        <code id="config-copy">
          &#60;script src="{window.location.origin}/sdk/{SDK_VERSION}/divshow.min.js?show_id={show_xid}"&#62;&#60;/script&#62;
        </code>
      </pre>
    </CodeBlock>
  )
}

export function BuilderJS(props){
  const api_key = props.api_key || "INSERT_API_KEY_HERE";
  const category = 'builder';

  return (
    <CodeBlock onCopy={() => onClickCodeCopy(category, api_key)} >
      <pre className="rounded highlight-quaternary-2">
        <code id="config-copy">
          &#60;script src="{window.location.origin}/sdk/{SDK_VERSION}/divshow_builder.min.js?api_key={api_key}"&#62;&#60;/script&#62;
        </code>
      </pre>
  </CodeBlock>
  )
}
